import { createSelector } from 'reselect';

import { selectFactory } from '../helpers';

import { DRIVER_ERROR_PREFIX, DRIVER_FIELDS, FIELDS } from './constants';

export const selectInsuranceAnketa = ({ insuranceAnketa }) => {
  return insuranceAnketa;
};

export const selectField = selectFactory({ selector: selectInsuranceAnketa });

export const selectErrors = selectField(FIELDS.ERRORS);
export const selectError = selectFactory({ selector: selectErrors });

export const selectDriver = (id) => {
  return createSelector(selectField(FIELDS.DRIVERS), (drivers) => {
    return drivers.find(({ [FIELDS.ID]: driverId }) => {
      return driverId === id;
    });
  });
};
export const selectDriverErrors = (id) => {
  return selectError(DRIVER_ERROR_PREFIX + id, {});
};
export const selectSomeDriverEdit = createSelector(selectField(FIELDS.DRIVERS), (drivers) => {
  return drivers.some(({ [DRIVER_FIELDS.EDIT]: edit }) => {
    return edit;
  });
});

export const selectKaskoInsurer = selectField(FIELDS.KASKO_INSURER);
export const selectKaskoInsurerField = selectFactory({ selector: selectKaskoInsurer });
export const selectKaskoInsurerErrors = selectKaskoInsurerField(FIELDS.ERRORS);
export const selectKaskoInsurerError = selectFactory({ selector: selectKaskoInsurerErrors });
